import GiftNameProvider from './hooks/useGiftName';

import { GiftNameProps } from './@types/GiftNameProps';

const GiftName = (props: GiftNameProps) => (
	<GiftNameProvider {...props}>
		{props.linkToProductPage ? (
			<a
				data-selection={`${props.componentId}`}
				href="/"
				className="vtex-product-gifts-0-x-giftNameLink giftNameLink c-on-base link"
			>
				<span className="vtex-product-gifts-0-x-giftNameText giftNameText">
					Camisa de Alfaiataria Louise Vermelha 46
				</span>
			</a>
		) : (
			<span data-selection={`${props.componentId}`} className="vtex-product-gifts-0-x-giftNameText giftNameText">
				Camisa de Alfaiataria Louise Vermelha 46
			</span>
		)}
	</GiftNameProvider>
);

export default GiftName;
